import { template as template_e82e9926b5504f4f872ca525ed18c4ea } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { Button, Tooltip } from '@cardstack/boxel-ui/components';
import { cn, eq } from '@cardstack/boxel-ui/helpers';
import { IconPlus } from '@cardstack/boxel-ui/icons';
export const SearchSheetTriggers = {
    DropCardToLeftNeighborStackButton: 'left',
    DropCardToRightNeighborStackButton: 'right'
} as const;
type Values<T> = T[keyof T];
export type SearchSheetTrigger = Values<typeof SearchSheetTriggers>;
interface Signature {
    Element: HTMLButtonElement;
    Args: {
        triggerSide: SearchSheetTrigger;
        activeTrigger: SearchSheetTrigger | null;
        onTrigger: (triggerSide: SearchSheetTrigger) => void;
    };
}
export default class NeighborStackTriggerButton extends Component<Signature> {
    private get tooltipPlacement() {
        return this.args.triggerSide === SearchSheetTriggers.DropCardToRightNeighborStackButton ? SearchSheetTriggers.DropCardToLeftNeighborStackButton : SearchSheetTriggers.DropCardToRightNeighborStackButton;
    }
    static{
        template_e82e9926b5504f4f872ca525ed18c4ea(`
    <Tooltip @placement={{this.tooltipPlacement}} ...attributes>
      <:trigger>
        <Button
          class={{cn
            'add-card-to-neighbor-stack'
            add-card-to-neighbor-stack--active=(eq @activeTrigger @triggerSide)
          }}
          {{on 'click' (fn @onTrigger @triggerSide)}}
          aria-label='Add card to {{@triggerSide}} stack'
          data-test-add-card-right-stack={{eq
            @triggerSide
            SearchSheetTriggers.DropCardToRightNeighborStackButton
          }}
          data-test-add-card-left-stack={{eq
            @triggerSide
            SearchSheetTriggers.DropCardToLeftNeighborStackButton
          }}
          data-test-neighbor-stack-trigger
        >
          <span class='icon-container'>
            <IconPlus class='add-icon' width='10' height='10' />
          </span>
        </Button>
      </:trigger>
      <:content>
        Open a card to the
        {{@triggerSide}}
        of the current card
      </:content>
    </Tooltip>
    <style scoped>
      .add-card-to-neighbor-stack {
        --minimized-width: 8px;
        --minimized-height: 20px;
        --expanded-width: 16px;
        --expanded-height: 66px;
        --boxel-transition: 100ms ease;
        --boxel-button-min-width: var(--expanded-width);
        --boxel-button-min-height: var(--minimized-height);
        height: calc(var(--expanded-height) / 2);
        width: var(--expanded-width);
        background: none;
        border: none;
        padding: 0;
      }
      .add-card-to-neighbor-stack:hover,
      .add-card-to-neighbor-stack:focus:focus-visible,
      .add-card-to-neighbor-stack--active {
        padding: 0;
        height: var(--expanded-height);
        outline-offset: 2px;
      }
      .icon-container {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: var(--minimized-width);
        height: var(--minimized-height);
        border-radius: inherit;
        background-color: var(--boxel-highlight);
        border: 2px solid rgba(0 0 0 / 50%);
        box-shadow: var(--boxel-deep-box-shadow);
        transition:
          height var(--boxel-transition),
          width var(--boxel-transition);
      }
      .add-card-to-neighbor-stack:hover .icon-container,
      .add-card-to-neighbor-stack:focus:focus-visible .icon-container,
      .add-card-to-neighbor-stack--active .icon-container {
        width: var(--expanded-width);
        height: var(--expanded-height);
      }
      .add-icon {
        visibility: collapse;
        transition: visibility var(--boxel-transition);
      }
      .add-card-to-neighbor-stack:hover .add-icon,
      .add-card-to-neighbor-stack:focus:focus-visible .add-icon,
      .add-card-to-neighbor-stack--active .add-icon {
        visibility: visible;
      }
    </style>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
